import Keycloak from 'keycloak-js';
import {createActivityTracker} from '../utils/activity-tracker.js';
import {useUploadStore} from "../stores/upload-store";

const keycloakConfig = {
    url: import.meta.env.VITE_KEYCLOAK_URL,
    realm: import.meta.env.VITE_KEYCLOAK_REALM,
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT,
    sslRequired: "external",
    resource: "testclient",
    publicClient: true,
    confidentialPort: 0
};

let keycloak = null;
let tracker = null;

function prepare(){

    // in case of re-login
    if (keycloak){
        keycloak.onAuthSuccess = null;
        keycloak.onAuthLogout = null;
        keycloak.clearToken?.();
    }
    if (tracker)
        tracker.disableListeners();

    keycloak = new Keycloak(keycloakConfig);
    tracker = createActivityTracker(keycloak);

    keycloak.onTokenExpired = async () => {
        console.log("token expired");

        /* hm, since we now do updateToken before each request (see tokenInterceptor in ../main.js), we don't need to take action here.
       also, updatingToken here had an edge case
       (when sending try and updateToken here coincided, the user was redirected to dashboard, with a confusing error message about not being authorized.)

       also, we are now proactively checking login status on user input (see createActivityTracker).

       Anyway, I don't think it's a good idea to refresh here unconditionally

         */
        const doRefresh = false;

        if (!doRefresh)
            return;
        else 
            // TODO: block beforeunload listeners below
            throw new Error("implement me");

        try {
            await keycloak.updateToken();
            console.log("succeeded refreshing token");
        } catch (err){
            console.log("error refreshing token:", err);
            // TODO: block beforeunload listeners here, see ../utils/messaging.js
            location.reload();
        };
    };

    keycloak.getRealmRoles = () => {
        return keycloak.realmAccess?.roles;
    }

    keycloak.checkTokenOrLogin = async () => {
        var minValidSeconds = 60;

        try {

            const now = Math.floor(Date.now() / 1000);
            const exp = keycloak.tokenParsed.exp;
            const iat = keycloak.tokenParsed.iat;
            const remaining = exp - now; // seconds until expiration

            const refreshRemaining = keycloak.refreshTokenParsed.exp - now;

            if (refreshRemaining < minValidSeconds) 
                // force refresh
                minValidSeconds = Number.MAX_SAFE_INTEGER;

            console.log(`checkTokenOrLogin: token valid for ${remaining} sec; refresh token for ${refreshRemaining} sec`);
            const wasRefreshed = await keycloak.updateToken(minValidSeconds);
            console.log("wasRefreshed:", wasRefreshed);

        } catch (err){
            if (err == 'Failed to refresh token: An unexpected HTTP error occurred while attempting to refresh the token.'){
                console.log("checkTokenOrLogin: updateToken failed - probably our session is expired");

                // remove error string 
                const redirectUri = window.location.href.replace(/[#&]error.*/, "");

                const uploadStore = useUploadStore();
                if (uploadStore.anything && 
                    window.relogin){
                    await window.relogin();
                } else {
                    // stop any beforeunload listeners from firing, otherwise user will get confirmation dialog if closing is ok, which would be confusing since user probably did not intend to close
                    window.onbeforeunload = null;

                    keycloak.login({redirectUri});
                }
            } else {
                throw new Error(err);
            }
        }
    };

    keycloak.onAuthSuccess = () => {
        tracker.enableListeners();
    };

    keycloak.onAuthLogout = () => {
        tracker.disableListeners();
    };
}

const install = (app, options) => {
    prepare();
    app.config.globalProperties.$keycloak = keycloak;
}

export {install};

export default install;



